<template>
  <div class="myExperiment" v-if="isLoading">
    <div class="myExperiment-title">
      <div class="search">
        <span>我的实验</span>
        <el-input
          placeholder="请输入内容"
          prefix-icon="el-icon-search"
          v-model="searchInput"
          @blur="getMyExperiment(active)"
          @keyup.native.enter="getMyExperiment(active)"
        >
        </el-input>
      </div>
      <div class="radioGroup">
        <el-radio-group v-model="radio" @change="radioChange">
          <el-radio label="2">必修</el-radio>
          <el-radio label="3">自修</el-radio>
          <el-radio label="4">收藏</el-radio>
        </el-radio-group>
      </div>
    </div>
    <div class="myExperiment-container">
      <div class="myExperiment-container-top" v-if="isShow == '2'">
        <div class="tabs">
          <div
            class="tabs-list"
            @click="toggleTabs(0)"
            :class="active == 0 ? 'active' : ''"
          >
            待学习
          </div>
          <div
            class="tabs-list"
            @click="toggleTabs(1)"
            :class="active == 1 ? 'active' : ''"
          >
            已完成
          </div>
        </div>
      </div>
      <div class="myExperiment-container-bottom" v-if="myExperiment.length > 0">
        <div class="container-list" v-for="item in myExperiment" :key="item.id">
          <experiment :id="item.id" :isMyExperiment="radio" @getMyExperiment="getMyExperiment"></experiment>
        </div>
      </div>
      <noDate v-else :tip="'暂无实验'" style="margin-top:150px"></noDate>
    </div>
  </div>
</template>

<script>
import experiment from "@/components/experiment.vue";
import noDate from '@/components/common/noData.vue'
export default {
  name: "VirtualimitationIndex",
  components: {
    experiment,
    noDate
  },
  data() {
    return {
      active: 0,
      isShow: "2",
      radio: "2", //2必修 3选修 4收藏
      searchInput: "",
      isLoading: false,
      myExperiment: null,
      params: {
        collegeId: 0,
        level: 0, //等级认定
        name: "",
        pageIndex: 1,
        showItem: 10,
        obligatory: 1, //0选修 1 必修
        favor: 0, // 1收藏
        status: 0, //我的实验，0 待学习 1 已完成  -1全部
        tagId: 0, //学科分类
      },
    };
  },

  mounted() {
    this.getMyExperiment(0);
  },

  methods: {
    getMyExperiment(status) {
      // this.myExperiment = [];
      this.params.status = status;
      this.params.name = this.searchInput;
      this.$api.experiment.getMyExperiment(this.params).then((res) => {
        if (res.errCode == 0) {
          this.myExperiment = res.data.items;
          this.isLoading = true;
        }
      });
    },
    toggleTabs(index) {
      this.active = index;
      this.getMyExperiment(index);
    },
    radioChange(val) {
      if (val == "2") {
        this.params.obligatory = 1; //必修
        this.params.favor = 0;
        this.active = 0;
        this.getMyExperiment(0);
        this.isShow = val;
        return;
      }
      if (val == "3") {
        this.params.favor = 0;
        this.params.obligatory = 2; //选修 
      }
      if (val == "4") {
        this.params.favor = 1; //收藏
        this.params.obligatory = 0;
        this.active = 0;
      }
      this.getMyExperiment(-1);
      this.isShow = val;
    },
  },
};
</script>

<style lang="less" scoped>
.myExperiment {
  width: 100%;
  min-height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  .myExperiment-container {
    flex:1;
    background: #fff;
    margin-top: 13px;
    .myExperiment-container-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #eef2fa;
      box-sizing: border-box;
      padding-left: 49px;
      padding-right: 37px;
      .tabs {
        display: flex;
        justify-content: start;
        align-items: center;
        .tabs-list {
          width: 55px;
          height: 58px;
          font-size: 16px;
          font-family: PingFang-SC;
          font-weight: 500;
          line-height: 58px;
          color: #5f656f;
          cursor: pointer;
          text-align: center;
          position: relative;
          &:nth-child(1) {
            margin-right: 70px;
          }
        }
      }
    }
    .myExperiment-container-bottom {
      padding: 0 27px;
      box-sizing: border-box;
      .container-list {
        padding: 27px 0;
        border-bottom: 1px solid #eef2fa;
      }
    }
  }
  .myExperiment-title {
    width: 100%;
    // height: 117px;
    padding: 31px 26px 23px;
    box-sizing: border-box;
    background: #fff;
    .radioGroup {
      margin: 31px auto 0;
      display: flex;
      justify-content: center;
      .el-radio-group {
        margin: 0 auto;
      }
    }
    .search {
      display: flex;
      justify-content: start;
      align-items: center;
      span {
        font-size: 20px;
        font-family: PingFang-SC;
        font-weight: 400;
        line-height: 28px;
        color: #101012;
        opacity: 1;
        margin-right: 382px;
      }
      .el-input {
        width: 604px;
      }
    }
  }
  /deep/ .el-input__prefix,
  .el-input__suffix {
    height: auto;
  }
}
.active {
  color: #1880fa;
  //   border-bottom: 2px solid #1880fa;
  &::before {
    content: "";
    display: block;
    width: 55px;
    height: 2px;
    background: #1880fa;
    position: absolute;
    bottom: 0;
    left: 0;
  }
}
</style>